.empty {
  flex-direction: column;
}

.title {
  margin-bottom: var(--rc-theme-spacing-xs);
  color: var(--rc-theme-color-text-default);
  font-weight: var(--rc-theme-font-weight-bold);
  text-align: center;
}
